/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Issue_Unknown_LineInputs */

const en_claim_issue_unknown_line = /** @type {(inputs: Claim_Issue_Unknown_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The line is not one of this order.`)
};

/**
* | output |
* | --- |
* | "The line is not one of this order." |
*
* @param {Claim_Issue_Unknown_LineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_issue_unknown_line = /** @type {((inputs?: Claim_Issue_Unknown_LineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Issue_Unknown_LineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_issue_unknown_line(inputs)
});